const PERMISSION_KEY= "personalize:nebula_performance_fees";
const PAGE_URL = {
    NEBULA_PERFORMANCE_FEE_PAGE: "/admin/personalize/nebula-performance-fee"
}

export {PERMISSION_KEY, PAGE_URL}

